<template>
  <v-container class="pa-0 full-h">
    <div class="pa-3">
      <span class="details-heading application-heading">Headlines</span>
    </div>
    <div class="grid-options-layout px-3">
      <!--      <v-select-->
      <!--        v-if="isHeadlineDropdownFeatureUnlocked"-->
      <!--        :disabled="analysisOnly"-->
      <!--        v-model="selectedHeadlineType"-->
      <!--        :items="filterOrder"-->
      <!--        @change="changeSelectedHeadlineType"-->
      <!--      >-->
      <!--      </v-select>-->

      <OverflowMenu
        v-if="isHeadlineDropdownFeatureUnlocked"
        :disabled="analysisOnly"
        :ordered-menu-items="filterOrder"
        :menu-items-count="menuItemsCount"
        :default-selected-menu-item="selectedHeadlineType"
        @selected-menu="changeSelectedHeadlineType"
      ></OverflowMenu>

      <v-tabs
        v-if="!isHeadlineDropdownFeatureUnlocked"
        :class="{ 'hyp-hide': showAnalysisOnly }"
        @change="handleHeadlinesToggle"
        v-model="tabIndex"
        :show-arrows="showArrows"
        mandatory
        centered
        grow
        ref="tabs"
      >
        <v-tab
          :disabled="analysisOnly"
          class="px-3 mx-0 type-tabs"
          v-for="filter in filterOrder"
          :key="filter"
        >
          {{ filter }}
        </v-tab>
      </v-tabs>
    </div>
    <div class="pa-3">
      <DateRangePicker
        :start="dates.start"
        :end="dates.end"
        size="small"
        class="pull-left"
        @change="handleChangeDate"
        v-if="!this.hotspotsEnabled"
      ></DateRangePicker>

      <v-btn
        v-if="
          this.analysisEnabled && !loading && items.length > 0 && showCopyBtn
        "
        class="pull-right ml-3 action-btn"
        outlined
        x-small
        @click="handleCopyClick"
      >
        <v-icon class="mr-2 left" size="12">far fa-clipboard</v-icon>
        Copy All
      </v-btn>

      <a
        @click="viewOnMapClick()"
        v-if="this.verifiedEventsEnabled && !loading && items.length > 0"
        class="pull-right ml-3"
        >View on Map</a
      >

      <v-btn-toggle
        v-model="sortBy"
        class="pull-right action-btn"
        v-if="this.analysisEnabled && !loading && items.length > 0"
      >
        <v-btn value="newest" x-small>
          <span class="hidden-sm-and-down">Newest</span>
        </v-btn>
        <v-btn value="oldest" x-small>
          <span class="hidden-sm-and-down">Oldest</span>
        </v-btn>
      </v-btn-toggle>
      <div class="clearfix"></div>
    </div>
    <Loader v-if="loading && !this.hotspotsEnabled" text="" color="black" />
    <RisksCountryHotspots
      v-if="this.hotspotsEnabled"
      :selected-location="selectedLocation"
      :params="params"
      class="px-3"
      @click-close="handleClickClose"
      @click-minimize="handleClickMinimize"
    ></RisksCountryHotspots>
    <div>
      <DetailsListCluster
        v-if="items.length > 0 && !this.hotspotsEnabled"
        theme="light"
        :items="items"
        :page="page"
        :pageSize="pageSize"
        :height-pixels="0"
        :height-percent="0"
        :show-primary-topics="true"
        :show-thumbs-down="true"
        :get-threshold-type-function="getThresholdTypeFunction"
        :get-live-search-params-function="getParams"
        :scroll-to-top="scrollToTop"
        :matomo-category="analyticsCategory"
        :show-copy-icon="showCopyBtn"
        :show-collaboration="showCollaboration"
        :show-inline-body="showInlineBody"
        @get-data="getContent"
        @loaded="loading = false"
        class="hyp-risks-country-headlines-list full-h"
      />
    </div>
    <h4
      class="text-center my-6"
      v-if="!loading && items.length === 0 && !this.hotspotsEnabled"
    >
      There are currently no live updates. Use the date range to search our
      archives.
    </h4>
    <v-overlay :absolute="true" :value="screenShotting">
      <div class="copy-overlay-indicator">
        <v-icon size="50" color="white">fas fa-check</v-icon>
        <div><strong>Copied</strong></div>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import lodashIsEmpty from "lodash/isEmpty";
import lodashIsEqual from "lodash/isEqual";
import lodashDebounce from "lodash/debounce";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashForOwn from "lodash/forOwn";
import lodashFind from "lodash/find";

import { getArticles, dataToCopy } from "@/services/search/wod.service";
import { getRiskCategories } from "@/services/controlRisks/risks.service";
import { getBreakingEvents } from "@/services/breakingEvents/breakingEvents.service";
import { setInfiniteScrollState } from "@/common/basic.utilities";
import { encodeAllURLParameters } from "@/common/api.utilities";
import {
  nowUtc,
  daysAgo30Utc,
  daysAgoUtc,
  getDifference,
  getTodayStartEndDate,
} from "@/common/date.utilities";
import { TRAVEL_RISK_RATING_ID } from "@/common/constants/controlRisks/risks";
import {
  getVerifiedEventTopicLayers,
  getAllPrimaryTopics,
} from "@/services/events/topics.service";
import {
  MAIN_MAP_ID,
  MAP_ICON_NAMES,
  MAP_ICON_COLORS,
} from "@/common/constants/maps";
import { LeftSidePanelWidthNumber } from "@/common/constants/layout";
import {
  getPrecision,
  getCountryByCode,
  getWaterByCode,
} from "@/common/maps/utilities";
import { MODULE_PREFIX_HOME, MODULE_PREFIX_MAP } from "@/store";
import { mapGetters } from "vuex";
import { httpGet } from "@/services/api.service";
import { addMapData } from "@/common/maps/features";
import { ENDPOINT_WOD_MAP } from "@/common/constants/api";
import { GET_DETAILS_SIDEBAR } from "@/store/actions.type";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import { SET_RESET_MAP_ICONS } from "@/store/mutations.type";
import {
  hasCopyAccess,
  hasBreakingEventsAccess,
  hasTwitterAccess,
  hasInternationalSOSAccess,
  hasMaritimeAccess,
} from "@/services/user/user.service";
import { SOCIAL_SOURCES } from "@/common/constants/wodSocialSources";

const EMITTED_ACTIONS = {
  CLICK_CLOSE: "click-close",
  CLICK_MINIMIZE: "click-minimize",
  SELECTED_TAB: "selected-tab",
  SELECTED_DATES: "selected-dates",
  SELECTED_SORT: "selected-sort",
  SELECTED_DATES_BY_USER: "selected-dates-by-user",
};

const FILTER_NAMES = {
  breakingEvents: "Breaking Events",
  analysis: "Analysis",
  verifiedEvents: "Verified Events",
  hotspots: "Hotspots",
  travel: "Travel",
};

export default {
  name: "RisksHeadlines",
  components: {
    RisksCountryHotspots: () =>
      import("@/components/controlRisks/risks/RisksCountryHotspots"),
    DetailsListCluster: () =>
      import("@/components/common/details/DetailsListCluster"),
    DateRangePicker: () => import("@/components/common/DateRangePicker"),
    Loader: () => import("@/components/common/Loader"),
    OverflowMenu: () => import("@/components/common/OverflowMenu"),
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
    params: {
      type: Object,
    },
    analysisOnly: {
      type: Boolean,
      default: false,
    },
    headlineParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedTabIndex: {
      type: Number,
    },
    selectedTabContent: {
      type: String,
    },
    selectedTabDates: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedTabDatesByUser: {
      type: Boolean,
      default: false,
    },
    selectedSort: {
      type: String,
    },
    overflowCurrentMenu: {
      type: Array,
    },
  },
  data() {
    const hasBreakingEvents = hasBreakingEventsAccess();

    const showAnalysisOnly = lodashGet(this.headlineParams, "showAnalysisOnly")
      ? lodashGet(this.headlineParams, "showAnalysisOnly")
      : false;

    let filterOrder = showAnalysisOnly
      ? [FILTER_NAMES.analysis]
      : [FILTER_NAMES.analysis, FILTER_NAMES.verifiedEvents];

    if (this.selectedLocation?.type === "country") {
      filterOrder.push(FILTER_NAMES.hotspots);
      if (
        hasInternationalSOSAccess() &&
        this.featureUnlocked("risk-category-travel")
      ) {
        filterOrder.push(FILTER_NAMES.travel);
      }
    }

    let showCopyBtn = hasCopyAccess();

    let breakingEventsEnabled = false;
    let analysisEnabled =
      !this.selectedTabContent || this.selectedTabContent === "analysis"
        ? true
        : false;

    if (hasBreakingEvents && this.selectedLocation?.type === "country") {
      filterOrder.splice(1, 0, FILTER_NAMES.breakingEvents);
      breakingEventsEnabled =
        this.selectedTabContent === "breakingEvents" ? true : false;
      analysisEnabled = breakingEventsEnabled ? false : analysisEnabled;
    }

    if (this.overflowCurrentMenu) {
      for (const item of filterOrder) {
        if (this.overflowCurrentMenu.indexOf(item) === -1) {
          this.overflowCurrentMenu.push(item);
        }
      }
      filterOrder = this.overflowCurrentMenu;
    }

    const selectedHeadlineType = this.selectedTabIndex
      ? filterOrder[this.selectedTabIndex]
      : breakingEventsEnabled
      ? FILTER_NAMES.breakingEvents
      : FILTER_NAMES.analysis;

    return {
      hasBreakingEvents: hasBreakingEvents,
      analyticsCategory: EVENT_CATEGORIES.control_risk_analysis,
      screenShotting: false,
      loading: false,
      breakingEventsEnabled: breakingEventsEnabled,
      analysisEnabled: analysisEnabled,
      verifiedEventsEnabled: this.selectedTabContent === "verified",
      hotspotsEnabled: this.selectedTabContent === "hotspot",
      travelEnabled: this.selectedTabContent === "travel",
      selectedHeadlineType: selectedHeadlineType,
      tabIndex: this.selectedTabIndex
        ? this.selectedTabIndex
        : filterOrder.indexOf(selectedHeadlineType),
      filterOrder: filterOrder,
      period: 0,
      regions: [],
      regionFilters: [],
      countryFilters: [],
      items: [],
      itemsResults: null,
      page: 1,
      pageSize: 25,
      timeout: null,
      scrollToTop: new Date().toISOString(),
      lastParams: null,
      sortBy: this.selectedSort ? this.selectedSort : "newest",
      currentType: null,
      idsPulled: [],
      lastTimestamp: null,
      idsPulledDetails: [],
      lastTimestampDetails: null,
      features: null,
      featuresResults: null,
      mapLayerId: "layer-rs",
      dates: lodashIsEmpty(this.selectedTabDates)
        ? {
            start: analysisEnabled
              ? daysAgoUtc(365)
              : breakingEventsEnabled
              ? daysAgoUtc(7)
              : daysAgo30Utc(),
            end: nowUtc(),
          }
        : {
            start: this.selectedTabDates.start,
            end: this.selectedTabDates.end,
          },
      datesSelectedByUser: this.selectedTabDatesByUser ?? false,
      showArrows: false,
      showAnalysisOnly: showAnalysisOnly,
      showCopyBtn: showCopyBtn,
      riskCategories: null,
      menuItemsCount: 3,
      currentMenu: this.overflowCurrentMenu,
    };
  },
  mounted() {
    this.initialize();
    this.updateShowArrows();
  },
  computed: {
    ...mapGetters({
      maps: MODULE_PREFIX_MAP + "maps",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
    showCollaboration() {
      return !this.breakingEventsEnabled;
    },
    showInlineBody() {
      return this.analysisEnabled || this.breakingEventsEnabled;
    },
    isHeadlineDropdownFeatureUnlocked() {
      return this.featureUnlocked("breaking-events");
    },
  },
  methods: {
    async initialize() {
      this.riskCategories = await getRiskCategories({
        ui: true,
      });
      this.loading = true;

      this.getContent();
    },
    getContent(page, $state, params) {
      if (!page) {
        this.scrollToTop = new Date().toISOString();
      }
      this.loading = true;
      this.getContentDebounced(page, $state, params);
    },
    getContentDebounced: lodashDebounce(async function (page, $state, params) {
      let result;
      let dataParams;
      try {
        this.loading = true;

        dataParams = this.getParams(params) || {};

        page = !page ? 1 : page;
        const PAGE_OFFSET = (page - 1) * this.pageSize;

        dataParams.pageSize = this.pageSize;
        dataParams.pageOffset = PAGE_OFFSET;

        let currParams = lodashCloneDeep(dataParams);
        if (currParams.hasOwnProperty("pageOffset")) {
          delete currParams.pageOffset;
        }

        let prevParams = lodashCloneDeep(this.lastParams);
        if (prevParams && prevParams.hasOwnProperty("pageOffset")) {
          delete prevParams.pageOffset;
        }
        if (!lodashIsEqual(currParams, prevParams)) {
          this.lastTimestamp = new Date().toISOString();
        }

        this.lastParams = dataParams;

        if (page > 1) {
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.scrolled,
            `Page ${page}`
          );
        }
        dataParams.idsPulled = this.lastTimestamp ? this.idsPulled : [];

        if (this.breakingEventsEnabled) {
          result = await getBreakingEvents(dataParams, this.lastTimestamp);
        } else {
          result = await getArticles(dataParams, this.lastTimestamp);
        }

        if (
          result &&
          result.features &&
          this.lastTimestamp ===
            lodashGet(
              result,
              "features[0].properties.formatted.requestTimestamp"
            )
        ) {
          if (
            this.itemsResults &&
            Array.isArray(this.itemsResults) &&
            this.itemsResults.length &&
            page !== 1
          ) {
            this.itemsResults = this.itemsResults.concat(result.features);
          } else {
            this.itemsResults = result.features;
          }
          this.items = lodashCloneDeep(this.itemsResults);
          this.idsPulled = dataParams.idsPulled;
          this.lastTimestamp = lodashGet(
            result,
            "features[0].properties.formatted.requestTimestamp"
          );
        } else {
          this.itemsResults = null;
          this.featuresResults = null;

          // If dates are default 30 days (not set by user and not set to be 365 from below) and no result, set it to be 365 days
          if (
            !this.datesSelectedByUser &&
            this.items?.length < 1 &&
            getDifference(this.dates.start, this.dates.end) < 364 &&
            !this.hotspotsEnabled &&
            !this.breakingEventsEnabled
          ) {
            this.dates.start = daysAgoUtc(365);
            this.dates.end = nowUtc();
            this.$emit(EMITTED_ACTIONS.SELECTED_DATES, this.dates);
            this.resetState();
            this.getContent();
          }
        }
      } catch (error) {
        console.error("Error in getContent: " + JSON.stringify(error));
        console.error(error);
      } finally {
        if (result) {
          setInfiniteScrollState(
            $state,
            { features: result.features },
            "features"
          );
        }
        this.page = page;
        this.loading = false;
        result = null;
      }
    }, 100),
    getParams() {
      const defaultParam =
        this.selectedLocation?.type === "country"
          ? {
              countryCode: this.selectedLocation.iso2Code,
              riskCategories:
                this.selectedPrimaryRiskCategory &&
                this.selectedPrimaryRiskCategory.riskCategoryId
                  ? this.selectedPrimaryRiskCategory.riskCategoryId
                  : null,
            }
          : {
              aoiId: this.selectedLocation.code,
            };
      let paramsCopy = lodashCloneDeep(this.params) || defaultParam;

      paramsCopy.aoiId =
        this.selectedLocation?.type === "country"
          ? paramsCopy.countryCode
          : paramsCopy.aoiId;
      paramsCopy.start =
        this.dates && this.dates.start
          ? getTodayStartEndDate(this.dates.start).start
          : this.analysisEnabled
          ? daysAgoUtc(365)
          : this.breakingEventsEnabled
          ? daysAgoUtc(7)
          : daysAgo30Utc();
      paramsCopy.end =
        this.dates && this.dates.end
          ? getTodayStartEndDate(this.dates.end).end
          : nowUtc();
      paramsCopy.pageSize = this.pageSize;
      paramsCopy.pageOffset = this.page * this.pageOffset;
      paramsCopy.sortDirection = this.sortBy === "newest" ? "desc" : "asc";

      paramsCopy.sources = this.getSource();
      paramsCopy.eventType = "all";
      if (this.verifiedEventsEnabled) {
        paramsCopy.eventType = "verified";
      }
      if (this.hotspotsEnabled) {
        paramsCopy.hotspotsOnly = true;
      }

      if (!paramsCopy.riskCategories) {
        if (this.travelEnabled) {
          paramsCopy.riskCategories = TRAVEL_RISK_RATING_ID;
        } else if (this.analysisEnabled) {
          paramsCopy.riskCategories = this.riskCategories
            .map((r) => r.id)
            .filter((r) => {
              return r !== TRAVEL_RISK_RATING_ID;
            })
            .join(",");
        }
      }
      return paramsCopy;
    },
    // copied from SearchContent
    getThresholdTypeFunction(doc) {
      let thresholdType = "cluster";
      if (
        lodashGet(doc, "properties.formatted.source") === "twitter.com" ||
        lodashGet(doc, "properties.formatted.source") === "twitter"
      ) {
        thresholdType = "twitter";
      }
      return thresholdType;
    },
    resetDates() {
      if (!this.datesSelectedByUser) {
        this.dates.start = this.analysisEnabled
          ? daysAgoUtc(365)
          : this.breakingEventsEnabled
          ? daysAgoUtc(7)
          : daysAgo30Utc();
        this.dates.end = nowUtc();
      }
    },
    resetState() {
      this.idsPulled = [];
      this.lastTimestamp = null;
      this.idsPulledDetails = [];
      this.lastTimestampDetails = null;

      this.page = 0;
      this.items = [];
      this.features = null;
    },
    getSource() {
      let sources = [];
      if (this.hotspotsEnabled) {
        sources.push("news");
        if (hasTwitterAccess()) {
          sources.push(SOCIAL_SOURCES);
        }
      }
      if (this.verifiedEventsEnabled) {
        if (this.selectedLocation?.type === "country") {
          sources.push("political");
        }
        if (hasMaritimeAccess()) {
          sources.push("maritime");
        }
      }
      if (this.analysisEnabled || this.travelEnabled) {
        sources.push("analysis");
      }
      return sources.toString();
    },
    handleHeadlinesToggle(selected) {
      this.analysisEnabled = false;
      this.verifiedEventsEnabled = false;
      this.hotspotsEnabled = false;
      this.travelEnabled = false;
      this.breakingEventsEnabled = false;
      if (!isNaN(selected)) {
        const _menu = this.isHeadlineDropdownFeatureUnlocked
          ? this.currentMenu
          : this.filterOrder;
        if (_menu[selected] === FILTER_NAMES.hotspots) {
          this.hotspotsEnabled = true;
          this.analyticsCategory = EVENT_CATEGORIES.hotspots;
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.selected,
            `Country risk - hotspots`
          );
        } else if (_menu[selected] === FILTER_NAMES.verifiedEvents) {
          this.verifiedEventsEnabled = true;
          this.analyticsCategory =
            EVENT_CATEGORIES.control_risk_verified_events;
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.selected,
            `Country risk - verified events`
          );
        } else if (_menu[selected] === FILTER_NAMES.analysis) {
          this.analysisEnabled = true;
          this.analyticsCategory = EVENT_CATEGORIES.control_risk_analysis;
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.selected,
            `Country risk - analysis`
          );
        } else if (_menu[selected] === FILTER_NAMES.travel) {
          this.travelEnabled = true;
          this.analyticsCategory = EVENT_CATEGORIES.isos_travel;
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.selected,
            `Country risk - Travel ISOS`
          );
        } else if (_menu[selected] === FILTER_NAMES.breakingEvents) {
          this.breakingEventsEnabled = true;
          this.analyticsCategory =
            EVENT_CATEGORIES.control_risk_breaking_events;
          this.handlePageTrackerEvent(
            this.analyticsCategory,
            EVENT_ACTIONS.selected,
            `Country risk - breaking events`
          );
        }
      }
      // selecting the type of filter for the current tab selected once its expand.
      let filter;
      if (this.hotspotsEnabled) {
        filter = "hotspot";
      } else if (this.travelEnabled) {
        filter = "travel";
      } else if (this.verifiedEventsEnabled) {
        filter = "verified";
      } else if (this.breakingEventsEnabled) {
        filter = "breakingEvents";
      } else {
        filter = "analysis";
      }
      this.$emit(
        EMITTED_ACTIONS.SELECTED_TAB,
        this.tabIndex,
        filter,
        this.currentMenu
      );
    },
    async handleCopyClick() {
      let items = lodashCloneDeep(this.items);

      const colsToCopy = [
        "title",
        "publishDate",
        "country",
        "water",
        "riskCategories",
        "body",
        "risks",
        "countriesWithFlag",
        "waters",
      ];

      if (this.selectedLocation?.type === "water") {
        const water = getWaterByCode(this.selectedLocation.code)?.name[0]?.text;
        items.forEach((value) => {
          value.properties.formatted.water = water;
        });
      }

      if (this.selectedLocation?.type === "country") {
        const country = JSON.parse(
          await getCountryByCode(this.selectedLocation.iso2Code)
        ).data.properties.officialName;

        items.forEach((value) => {
          value.country = country;
        });
      }

      document.activeElement.blur();

      this.screenShotting = true;

      this.handlePageTrackerEvent(
        this.analyticsCategory,
        EVENT_ACTIONS.clicked,
        "Copy To Clipboard"
      );

      await dataToCopy(items, colsToCopy, false);

      setTimeout(() => {
        this.screenShotting = false;
      }, 500);
    },
    handleChangeDate(dates) {
      this.datesSelectedByUser = dates?.start || dates?.end ? true : false;
      const start =
        dates && dates.start
          ? dates.start
          : this.analysisEnabled
          ? daysAgoUtc(365)
          : this.breakingEventsEnabled
          ? daysAgoUtc(7)
          : daysAgo30Utc();
      const end = dates && dates.end ? dates.end : nowUtc();
      this.dates = { start, end };
      this.$emit(EMITTED_ACTIONS.SELECTED_DATES, this.dates);
      this.$emit(
        EMITTED_ACTIONS.SELECTED_DATES_BY_USER,
        this.datesSelectedByUser
      );
      this.resetState();
      this.getContent();
    },
    async clearDataLayers() {
      await this.$store.commit(
        MODULE_PREFIX_MAP + SET_RESET_MAP_ICONS,
        new Date()
      );
    },
    async viewOnMapClick() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);

      if (
        this.map &&
        this.selectedLocation &&
        this.selectedLocation.minLongitude &&
        this.selectedLocation.minLatitude &&
        this.selectedLocation.maxLongitude &&
        this.selectedLocation.maxLatitude
      ) {
        const bbox = [
          [
            this.selectedLocation.minLongitude,
            this.selectedLocation.minLatitude,
          ],
          [
            this.selectedLocation.maxLongitude,
            this.selectedLocation.maxLatitude,
          ],
        ];
        const fitBoundsPadding = 40;
        this.map.fitBounds(bbox, {
          padding: {
            top: fitBoundsPadding,
            bottom: fitBoundsPadding,
            right: fitBoundsPadding + LeftSidePanelWidthNumber,
            left: fitBoundsPadding + LeftSidePanelWidthNumber,
          },
        });
      }

      await this.clearDataLayers();
      const eventLayers = getVerifiedEventTopicLayers();
      lodashForOwn(eventLayers, async (value, key) => {
        let t = [];
        if (Array.isArray(value) && value.length) {
          t = value;
        } else {
          t.push(`topic-${key}`);
        }
        const endpoint = await this.getMapEndpoint(t);
        await this.addLayerToMap({
          id: `${this.mapLayerId}-topic-${key}`,
          aggData: endpoint,
          map: this.map,
          iconName: MAP_ICON_NAMES[key],
          mapClickEvent: this.mapClickEvent,
          clusterMapClickEvent: this.mapClickEvent,
        });
      });
      this.handlePageTrackerEvent(
        this.analyticsCategory,
        EVENT_ACTIONS.addDataToMap,
        "Country risk - view on map"
      );
    },
    mapClickEvent(e) {
      e.originalEvent.stopPropagation();

      this.currentType = e.eventLayers[0]
        .replace("layer-", "")
        .replace("rs-", "")
        .replace("topic-", "")
        .replace("-geohash", "")
        .replace("-cluster", "");

      this.showSidebar();
    },
    async showSidebar() {
      let showTime = new Date().getTime();
      await this.setSidebar({ initial: true, showTime: showTime });
    },
    getMapEndpoint(type) {
      let params = this.getParams();
      params.pageOffset = 1;
      params.sortDirection = undefined;

      params.eventType = "verified";
      params.sources = this.getSource();

      if (type && Array.isArray(type) && type[0].includes("topic-")) {
        let topics = [];
        type.forEach((t) => {
          const event = t.split("topic-");
          if (event && Array.isArray(event) && event.length > 1) {
            topics.push(event[1]);
          }
        });
        params.topics = topics.join();
      }

      params.mapType = "marker";
      params.precision = getPrecision(this.map);
      params.pageSize = 10000;
      return encodeAllURLParameters({
        baseEndpoint: ENDPOINT_WOD_MAP,
        params: params,
      });
    },
    async addLayerToMap(layerOptions) {
      try {
        const RESULT = await httpGet({
          url: layerOptions.aggData,
        });
        const { data } = JSON.parse(RESULT);
        layerOptions.data = data;

        addMapData(layerOptions);
      } catch (error) {
        console.error("Failed to retrieve data for layer");
        console.error(error);
      }
    },
    async setSidebar(params) {
      //if a more recent click has updated sidebar please stop
      if (this.$store.state.home.detailsSidebar.showTime > params.showTime) {
        return null;
      }
      if (this.currentType) {
        let title = this.currentType;
        let type = this.currentType;
        const TOPICS_ARRAY = getAllPrimaryTopics();
        const topic = lodashFind(TOPICS_ARRAY, {
          apiName: this.currentType,
        });
        if (topic) {
          title = topic.plural;
          type = topic.apiName;
          if (topic.parentIds && topic.parentIds[0]) {
            const parent = lodashFind(TOPICS_ARRAY, {
              apiName: topic.parentIds[0],
            });
            if (parent) {
              type = parent.apiName;
              title = `${parent.plural} > ${topic.plural}`;
            }
          }
        }

        this.detailsSidebar.loading = false;
        this.detailsSidebar.visible = true;
        this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.mapClick;
        this.detailsSidebar.type = type;

        this.detailsSidebar.title = title;
        this.detailsSidebar.features = [];
        this.detailsSidebar.total = null;

        this.detailsSidebar.iconColor = MAP_ICON_COLORS[type];
        this.detailsSidebar.iconName = MAP_ICON_NAMES[type];

        this.detailsSidebar.hideSearchBar = true;

        if (params.initial) {
          this.detailsSidebar.loading = true;
          this.detailsSidebar.features = null;
          this.detailsSidebar.total = null;
          this.detailsSidebar.keywords = null;
          this.selectedKeywords = [];
        }

        if (params.showTime) {
          this.detailsSidebar.showTime = params.showTime;
        }

        this.detailsSidebar.SelectorSourceRef = this;

        this.detailsSidebar.getParamsFunction = this.getParams;

        await this.$store.dispatch(
          MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
          this.detailsSidebar
        );
      }
    },
    async getData(params, page) {
      // this is used to get the data for the right slideout when user clicks on map icon
      params = params ? params : {};

      let result;
      try {
        page = !page ? 1 : page;
        const PAGE_OFFSET = (page - 1) * this.pageSize;

        params.pageSize = this.pageSize;
        params.pageOffset = PAGE_OFFSET;
        params.idsPulled = this.lastTimestampDetails
          ? this.idsPulledDetails
          : [];

        result = await getArticles(params, this.lastTimestampDetails);

        if (result && result.features) {
          if (
            this.featuresResults &&
            Array.isArray(this.featuresResults) &&
            this.featuresResults.length &&
            page !== 1 &&
            result.features.length
          ) {
            this.featuresResults = this.featuresResults.concat(result.features);
          } else {
            this.featuresResults = result.features;
          }
          this.features = lodashCloneDeep(this.featuresResults);
        } else {
          this.features = null;
          this.featuresResults = null;
        }

        this.idsPulledDetails = params.idsPulled;
        this.lastTimestampDetails = lodashGet(
          this,
          "features[0].properties.formatted.requestTimestamp"
        );
      } catch (error) {
        console.error("Error in getData: " + JSON.stringify(error));
      } finally {
        result = null;
      }
    },
    updateShowArrows() {
      let tabsContainer = this.$refs?.tabs?.$el;
      let tabsElement = tabsContainer
        ? tabsContainer.querySelector(".v-slide-group__content")
        : null;
      if (tabsContainer && tabsElement) {
        let containerWidth = tabsContainer.clientWidth;
        let tabsWidth = tabsElement.clientWidth;
        this.showArrows = containerWidth < tabsWidth;
      }
    },
    changeSelectedHeadlineType(params) {
      // previous drop down logic
      // this.selectedHeadlineType = selectedHeadlineType;
      // this.tabIndex = this.filterOrder.indexOf(selectedHeadlineType);
      // this.handleHeadlinesToggle(this.tabIndex);

      this.currentMenu = params.currentMenu;

      this.verifiedEventsEnabled = params.item === FILTER_NAMES.verifiedEvents;
      this.analysisEnabled = params.item === FILTER_NAMES.analysis;
      this.hotspotsEnabled = params.item === FILTER_NAMES.hotspots;
      this.breakingEventsEnabled = params.item === FILTER_NAMES.breakingEvents;
      this.travelEnabled = params.item === FILTER_NAMES.travel;

      this.selectedHeadlineType = params.item;
      this.tabIndex = this.isHeadlineDropdownFeatureUnlocked
        ? this.currentMenu?.indexOf(this.selectedHeadlineType)
        : this.filterOrder?.indexOf(this.selectedHeadlineType);
      this.handleHeadlinesToggle(this.tabIndex);
    },
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE);
    },
    handleClickMinimize() {
      this.$emit(EMITTED_ACTIONS.CLICK_MINIMIZE);
    },
  },
  watch: {
    params: {
      async handler() {
        this.filterOrder = this.showAnalysisOnly
          ? [FILTER_NAMES.analysis]
          : [FILTER_NAMES.analysis, FILTER_NAMES.verifiedEvents];
        if (this.selectedLocation?.type === "country") {
          this.filterOrder.push(FILTER_NAMES.hotspots);
          if (
            hasInternationalSOSAccess() &&
            this.featureUnlocked("risk-category-travel")
          ) {
            this.filterOrder.push(FILTER_NAMES.travel);
          }
        }

        this.breakingEventsEnabled = false;
        if (
          this.hasBreakingEvents &&
          this.selectedLocation?.type === "country"
        ) {
          this.filterOrder.splice(1, 0, FILTER_NAMES.breakingEvents);
        }
        this.analysisEnabled = !this.breakingEventsEnabled;

        this.verifiedEventsEnabled = false;
        this.hotspotsEnabled = false;
        this.travelEnabled = false;

        this.selectedHeadlineType = this.breakingEventsEnabled
          ? FILTER_NAMES.breakingEvents
          : FILTER_NAMES.analysis;

        this.tabIndex = this.filterOrder.indexOf(this.selectedHeadlineType);

        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    breakingEventsEnabled: {
      async handler() {
        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    analysisEnabled: {
      async handler() {
        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    verifiedEventsEnabled: {
      async handler() {
        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    hotspotsEnabled: {
      async handler() {
        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    travelEnabled: {
      async handler() {
        this.resetDates();
        this.resetState();
        this.getContent();
      },
      deep: true,
    },
    sortBy: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit(EMITTED_ACTIONS.SELECTED_SORT, newVal);
          this.resetState();
          this.getContent();
        }
      },
    },
    selectedPrimaryRiskCategory: {
      handler() {
        if (
          this.selectedPrimaryRiskCategory &&
          this.selectedPrimaryRiskCategory.id
        ) {
          this.analysisEnabled = true;
          this.verifiedEventsEnabled = false;
          this.hotspotsEnabled = false;
          this.travelEnabled = false;
          this.breakingEventsEnabled = false;
        }
        this.resetState();
        this.getContent();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style>
.hyp-risks-country-headlines-list .container,
.hyp-risks-country-headlines-list .container > * {
  height: 100%;
}
.hyp-risks-country-headlines-list .content-container {
  scrollbar-color: unset;
}
</style>
<style scoped>
.details-heading {
  font-size: 20px;
}
/* Content type checkboxes */
>>> .v-input--selection-controls {
  margin-top: 0;
}
>>> .v-input__slot .v-input--selection-controls__input {
  margin-bottom: auto;
}
.grid-options-layout-entry >>> .v-label {
  font-size: 13px;
}
>>> .v-input--selection-controls.v-input--dense
  .v-input--selection-controls__ripple {
  width: 18px;
  height: 18px;
  top: calc(50% - 16px);
}
>>> .v-input__slot .v-input--selection-controls__input {
  margin-bottom: auto;
  height: 15px;
  width: 15px;
  top: 2px;
}
>>> .v-input--selection-controls .v-icon.v-icon--dense {
  font-size: 15px;
}

.grid-options-layout {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: left;
}

.v-overlay {
  left: 0 !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-overlay--active.v-overlay {
  background-color: rgba(0, 0, 0, 0.75) !important;
}
.action-btn {
  position: relative;
  top: 7px;
}
.copy-overlay-indicator {
  width: 120px;
  height: 120px;
  background-color: green;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  font-size: large;
}
.full-h {
  height: 100%;
}
@media only screen and (max-width: 1200px) {
  .ve {
    margin-top: 10px;
    padding-left: 10px !important;
  }
  .grid-options-layout {
    flex-wrap: wrap;
  }
}
.type-tabs {
  font-size: smaller;
}
</style>
